import { Reveal } from "@/components/Reveal";

const EXPERIENCES = [
  {
    num: "01",
    title: "In-Villa Private Chef",
    desc: "Floating breakfasts at dawn, candlelit dinners at dusk — menus built around you.",
    img: "https://images.pexels.com/photos/28539228/pexels-photo-28539228.jpeg?auto=format&fit=crop&w=1000&q=85",
  },
  {
    num: "02",
    title: "Wellness & Spa Rituals",
    desc: "Balinese massage, sound healing, and yoga shalas without leaving your sanctuary.",
    img: "https://images.unsplash.com/photo-1637412816281-f80ec9948fea?auto=format&fit=crop&w=1000&q=85",
  },
  {
    num: "03",
    title: "Sunset Yacht Charters",
    desc: "Private speedboats and golden-hour sails along the Bukit coastline.",
    img: "https://images.unsplash.com/photo-1600494448655-ae58f58bb945?auto=format&fit=crop&w=1000&q=85",
  },
  {
    num: "04",
    title: "Island Chauffeur",
    desc: "Hidden beaches, temple sunrises, and rice-terrace roads — with a driver who knows them all.",
    img: "https://images.pexels.com/photos/8082562/pexels-photo-8082562.jpeg?auto=format&fit=crop&w=1000&q=85",
  },
];

export const Experiences = () => (
  <section id="experiences" className="bg-ink py-24 text-ivory sm:py-32 lg:py-40" data-testid="experiences-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="mb-5 flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.3em] text-ivory/50">
          <span className="h-px w-10 bg-gold" /> Island Lifestyle
        </p>
        <h2 className="max-w-3xl font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          Tailored <span className="italic text-gold">Experiences</span>
        </h2>
        <p className="mt-6 max-w-xl text-sm font-light leading-relaxed text-ivory/60 sm:text-base">
          Elevate your stay with curated experiences delivered directly to your
          villa sanctuary — arranged in a single WhatsApp message.
        </p>
      </Reveal>

      <div className="mt-16">
        {EXPERIENCES.map((exp, i) => (
          <Reveal key={exp.num} delay={0.05 * i}>
            <div
              data-testid={`experience-item-${i}`}
              className="group grid items-center gap-6 border-t border-ivory/10 py-8 transition-colors duration-500 sm:grid-cols-12 sm:py-10"
            >
              <span className="font-serif text-sm italic text-gold sm:col-span-1">{exp.num}</span>
              <h3 className="font-serif text-3xl font-light tracking-tight transition-colors duration-500 group-hover:text-gold sm:col-span-4 sm:text-4xl">
                {exp.title}
              </h3>
              <p className="text-sm font-light leading-relaxed text-ivory/60 sm:col-span-4">
                {exp.desc}
              </p>
              <div className="img-frame aspect-[16/10] w-full overflow-hidden sm:col-span-3">
                <img
                  src={exp.img}
                  alt={exp.title}
                  loading="lazy"
                  className="h-full w-full object-cover opacity-80 transition-opacity duration-700 group-hover:opacity-100"
                />
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
